import React, { useState, useEffect } from "react";
import SearchIcon from "@mui/icons-material/Search";

// bootrap
import { Button, Table, Form, InputGroup, Row, Col, Spinner } from "react-bootstrap";
import moment from "moment";
// import EmptyComponent from "../../components/EmptyComponent";
import { COLOR_WHITE, LINEAR_GRADIENT_BG, STATUS_TAG_KEYS, STOCK_OPTION_TAG_KEYS } from "../../../../const";
import CustomButton from "../../../../components/CustomButton";
import FormStockOption from "./FormStockOption";
import { useLazyQuery, useMutation } from '@apollo/client';
import { GET_STOCKS_OPTIONS } from "../../../../apollo/stockOption/query";
import { toast } from "react-toastify";
import { MSG_CREATE_SUCCESS, MSG_DATA_NOT_FOUND, MSG_INCOMPLETE_DATA, MSG_INTERNAL_ERROR, MSG_LOADING, MSG_SUCCESS } from "../../../../const/msg";
import { ReactIcons } from "../../../../icons";
import LoadingSpinner from "../../../../components/LoadingSpinner";
import { UPDATE_STOCK_OPTION } from "../../../../apollo/stockOption/mutation";
const mode = ["view", "add", "edit"];

export default function StockOptions({ tabKey }) {
  //TODO State
  const [total, setTotal] = useState(0);
  const [optionList, setOptionList] = useState([]);
  const [clickMode, setClickMode] = useState(mode[0]);
  const [searchName, setSearchName] = useState("");
  const [searchStatus, setSearchStatus] = useState("");
  const [searchTag, setSearchTag] = useState("");
  const [selectItem, setSelectItem] = useState({});

  //TODO Apollo
  const [getStockOptions, { loading: loadingGetStockOptions }] = useLazyQuery(GET_STOCKS_OPTIONS, { fetchPolicy: "cache-and-network"});
  const [updateStockOption, { loading: loadingUpdateStockOption }] = useMutation(UPDATE_STOCK_OPTION);

  //TODO useEffect
  useEffect(() => {
    console.log("useEffect, stockOption");
    if (tabKey === "stockOption" && clickMode === mode[0]) {
      console.log({clickMode});
      // Create the controller in the effect
      const controller = new AbortController();
      
      // Add a small delay before fetching to prevent rapid requests
      const timeoutId = setTimeout(() => {
        // Only fetch if the component is still mounted (controller not aborted)
        if (!controller.signal.aborted) {
          handleFetchStockOptions(controller.signal)
            .then(result => {
              // Handle successful result if needed
              console.log("result", result);
            })
            .catch(err => {
              // This shouldn't happen as errors are caught in the function
              console.error("Unhandled error:", err);
            });
        }
      }, 100);
      
      // Return proper cleanup function
      return () => {
        clearTimeout(timeoutId); // Clear the timeout
        controller.abort(); // Abort any in-flight requests
      };
    };
  }, [tabKey, searchName, searchStatus, searchTag, clickMode]);
  // useEffect(() => {
  //     if(dataGetStockOptions && clickMode === mode[0] && !cancel){
  //       console.log("setOption");
  //       console.log({dataGetStockOptions})
  //       // const response = JSON.parse(dataGetStockOptions?.getStockOptions.response);
  //       // const {status, stockOption, total, msg} = response;
  //       // console.log({status, stockOption, total, msg});
  //       // if (status) {
  //       //     setOptionList(stockOption || []);
  //       //     setTotal(total || 0);
  //       //     return toast.success(MSG_SUCCESS);
  //       // } else {
  //       //     return toast.error(msg);
  //       // }
  //     }
  // }, [dataGetStockOptions]);

  //TODO Function
  const handleFetchStockOptions = async (signal) => {
    if (loadingGetStockOptions){
      return toast.warning(MSG_LOADING);
    }

    try {
      let where = {}
      if (searchStatus !== "") {
        where = {
          ...where,
          status: searchStatus
        }
      }
      if (searchTag !== "") {
        where = {
          ...where,
          tag: searchTag
        }
      }
      if (searchName !== "") {
        where = {
          ...where,
          name: searchName
        }
      }
      console.log("handleFetchStockOptions....", where);
      const response = await getStockOptions({
        variables: {
          where: where,
          limit: 50,
        },
        context: { fetchOptions: { signal } }, // Pass the abort signal
      });
      const _response = await JSON.parse(response?.data?.getStockOptions);
        const {status, stockOption, total, msg} = _response;
        // console.log({status, stockOption, total, msg});
        if (status) {
            setOptionList(stockOption || []);
            setTotal(total || 0);
            return toast.success(MSG_SUCCESS);
        } else {
            return toast.error(msg);
        }
      return response?.data
    } catch (error) {
      // If it's an abort error, it's not a real error - just log it
      if (error.name === 'AbortError') {
        console.log("Request was aborted intentionally");
        // Don't show an error toast for intentional aborts
        return null;
      } else {
        // For real errors, log and show toast
        console.error("Error in handleFetchStockOptions:", error);
        setTotal(0);
        setOptionList([]);
        toast.error(MSG_INTERNAL_ERROR);
        return null;
      }
    }
  };

  const handleUpdateStockOption = async (values, index) => {
    if (loadingUpdateStockOption) {
        return toast.warning(MSG_LOADING);
    };
    if (!values) {
        return toast.error(MSG_INCOMPLETE_DATA);
    };
    console.log("values", values);
    try {
        const updateDataStockOption = {
            status: !values?.status
        }
        const where = {
            tag: values?.tag,
            stockOption: values?._id
        }
        // console.log("where, data", where, updateDataStockOption);
        console.log("handleUpdateStockOption....");
        const res = await updateStockOption({
            variables: {
                data: updateDataStockOption, where
            }
        });
        const response = JSON.parse(res?.data?.updateStockOption);

        const {status, msg} = response;
        if (status) {
            // set new data stock options
            const newStatus = !values?.status;
            let updatedStockOptions = [...optionList];
            const {tag} = updatedStockOptions[index];
            if (tag === "PLUS" ) {
              const activeTag = optionList.find((o) => {
                if (o?.status === true && o?.tag === "PLUS"){
                  return o;
                }
              });
              if (activeTag && activeTag?._id !== values?._id){
                // find active index 
                const activeIndex = optionList.findIndex((i) => i._id === activeTag?._id);
                if (activeIndex !== -1) {
                  updatedStockOptions[activeIndex] = { 
                    ...updatedStockOptions[activeIndex], 
                    status: false 
                  };
                }
              }
            }
            updatedStockOptions[index] = {...updatedStockOptions[index], status: newStatus};
            setOptionList(updatedStockOptions);
            return toast.success(MSG_CREATE_SUCCESS);
        } else {
            return toast.error(msg);
        }
    } catch (error) {
        console.log("Error in handleCreate: ",error);
        return toast.error(MSG_INTERNAL_ERROR);
    }
};

  //TODO Render
  return (
    <React.Fragment>
      {clickMode === mode[0] ? (
        <div className="main">
          <Row style={{ marginTop: "1em" }}>
            <Col style={{ width: "20%" }}>
              <InputGroup>
                {/* //!Icon search */}
                <InputGroup.Text
                  style={{
                    backgroundColor: "#FFFFFF",
                  }}>
                  <SearchIcon sx={{ color: "#6B7280" }} />
                </InputGroup.Text>
                {/* //!Box search */}
                <Form.Control
                  placeholder="ຄົ້ນຫາສິນຄ້າ..."
                  aria-describedby="basic-addon2"
                  onChange={(e) => {
                    setSearchName(e.target.value);
                  }}
                  value={searchName}
                  style={{
                    borderLeft: "none",
                  }}
                />
              </InputGroup>
            </Col>
            <Col style={{ width: "15%", paddingLeft: "10px" }}>
              <Form.Select
                style={{
                  height: "40px",
                  color: "#6B7280",
                  cursor: "pointer",
                }}
                onChange={(e) => {
                  setSearchStatus(e.target.value);
                }}
                value={searchStatus}
                >
                {STATUS_TAG_KEYS?.map((s) => (
                  <option key={s.key} value={s?.value}>
                    {s?.key}
                  </option>
                ))}
              </Form.Select>
            </Col>
            <Col style={{ width: "15%", paddingLeft: "10px" }}>
              <Form.Select
                style={{
                  height: "40px",
                  color: "#6B7280",
                  cursor: "pointer",
                }}
                onChange={(e) => {
                  setSearchTag(e.target.value);
                }}
                value={searchTag}
              >
                <option value="">ເເທັກທັງໝົດ</option>
                {STOCK_OPTION_TAG_KEYS?.map((t) => (
                  <option key={t?.key} value={t?.value}>
                    {t?.key}
                  </option>
                ))}
              </Form.Select>
            </Col>
            <Col style={{ display: "flex", gap: 10, paddingLeft: "10px" }}>
              <CustomButton
                // disabled={totalAmount <= 0 ? true : false}
                height={40}
                width={100}
                borderRadius={8}
                title={`ເພີ່ມ`}
                background={clickMode === mode[1] ? "gray" : LINEAR_GRADIENT_BG}
                onClick={() => setClickMode(mode[1])}
              />
            </Col>
          </Row>

          <div className="stock_options-content">
            <Table
              hover
              style={{
                marginTop: "20px",
                borderCollapse: "collapse",
                width: "100% ",
                cursor: "pointer",
                borderRadius: "20px",
              }}>
              <thead
                style={{
                  background: LINEAR_GRADIENT_BG,
                  borderRadius: " 8px 8px 0px 0px",
                  color: "#FFFFFF",
                }}>
                <tr>
                  <th style={{ verticalAlign: "middle", fontSize: 13 }}>ລ/ດ</th>
                  <th style={{ verticalAlign: "middle", fontSize: 13 }}>ຫົວຂໍ້</th>
                  <th style={{ verticalAlign: "middle", fontSize: 13 }}>ແທັກການໃຊ້ງານ</th>
                  <th style={{ verticalAlign: "middle", fontSize: 13 }}>ສະຖານະ</th>
                  <th style={{ verticalAlign: "middle", fontSize: 13 }}>ວັນທີ່</th>
                  <th style={{ verticalAlign: "middle", fontSize: 13 }}>ຈັດການ</th>
                </tr>
              </thead>
              <tbody>
                {optionList.length > 0 ?(
                  <>
                    {optionList?.map((i, index) => (
                      <tr key={i + index}>
                        <td style={{ verticalAlign: "middle", fontSize: 13 }}>{index + 1}</td>
                        <td style={{ verticalAlign: "middle", fontSize: 13 }}>{i?.name ?? '-'}</td>
                        <td style={{ verticalAlign: "middle", fontSize: 13 }}> {STOCK_OPTION_TAG_KEYS.find((item) => item.value === i?.tag)?.key ?? i?.tag ?? '-'}</td>
                        <td style={{ verticalAlign: "middle", fontSize: 13, color: i?.status ? "green" : "red" }}> {i?.status ? "ເປີດ" : "ປີດ" ?? i?.status}</td>
                        <td style={{ verticalAlign: "middle", fontSize: 13 }}> {moment(i?.updatedAt).format("DD/MM/YYYY")}</td>
                        <td>
                          <div
                            style={{ display: "flex", alignItems: "center" , gap: 5, justifyContent:'start'}}>
                            <Button variant="outline-primary" 
                              onClick={() => {setClickMode(mode[2]); setSelectItem(i)}}
                            ><ReactIcons.FaEdit /></Button>
                            <Button disabled={loadingUpdateStockOption} variant={i?.status === "ACTIVED" ? "success" : "outline-danger"} onClick={() => handleUpdateStockOption(i, index)}>
                                {(loadingUpdateStockOption) ? <Spinner size="sm" /> : <ReactIcons.FaCheck />}
                            </Button>
                          </div>
                        </td>
                      </tr>
                    ))}
                    <tr>
                      <td colSpan={6} style={{ textAlign: "center", verticalAlign: "middle", fontSize: 13 }}>{total}</td>
                    </tr>
                  </>
                )
                :
                <tr>
                  <td colSpan={6} style={{ textAlign: "center", verticalAlign: "middle", fontSize: 13 }}>
                    {loadingGetStockOptions ? <LoadingSpinner /> : MSG_DATA_NOT_FOUND}
                  </td>
                </tr>
                }
            </tbody>
            </Table>
          </div>
        </div>
      ) : (
        <div className="main" style={{ background: COLOR_WHITE, display: "flex", justifyContent: "center", alignItems: "center" }}>
            < FormStockOption data={selectItem} clickMode={clickMode} setClickMode={setClickMode} />
        </div>
      )}
  </React.Fragment>
  );
  
}
